// extracted by mini-css-extract-plugin
export default {"skeletonCell":"SkeletonCell_skeletonCell__+78co","shimmer":"SkeletonCell_shimmer__Giqtb"};